<template>
    <div class="ivu-spin ivu-spin-fix">
        <div class="ivu-spin-main">
            <span class="ivu-spin-dot"></span>
            <div class="ivu-spin-text"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "accountRouter",
        created: function(){
            const self = this;
            self.FoxRequest(window.settings.api_url + 'index/account/check_login', {

            }, function(response){
                let data = response.data;
                if (data.error == 0){
                    // self.$router.push("/shop/list");
                }else{
                    self.$router.push("/account/login");
                }
            });
        }
    }
</script>

<style scoped>

</style>